<template>
  <div class="search-bar">
    <div class="search-bar__wrapper">
      <input
        v-model="term"
        :placeholder="$t('c.searchBar.form.placeholder.search')"
        class="search-bar__input"
        type="text"
        @keyup.enter="customSubmit"
        @keyup.esc="reset"
      >

      <button-input
        class="content__share-button"
        @click="openFilterModal()"
      >
        <font-awesome-icon icon="filter" />
        <span
          v-t="'c.searchBar.navigation.filter'"
          class="visuallyhidden"
        />
      </button-input>
    </div>

    <div
      v-if="contents.length"
      class="search-bar__controls"
    >
      <div class="search-bar__column search-bar__column--left">
        <button-input @click="openExportModal">
          <font-awesome-icon icon="cloud-upload-alt" />
          Exportieren
        </button-input>
      </div>

      <div class="search-bar__column search-bar__column--center">
        <content-layout-switch />
      </div>

      <div class="search-bar__column search-bar__column--right">
        <dropdown-input
          :options="sortByOptions"
          theme="primary"
          position="right"
          @select="handleSortBySelect"
        >
          <button-input>
            <font-awesome-icon :icon="sortDirIcon" />
            <font-awesome-icon icon="angle-down" />
          </button-input>
        </dropdown-input>
      </div>
    </div>

    <search-filter-overlay />
    <content-export-overlay />
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import FormMixin from '@/mixins/forms/Form'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import ContentLayoutSwitch from '@/components/contents/ContentLayoutSwitch'
import SearchFilterOverlay from '@/components/search/SearchFilterOverlay'
import ContentExportOverlay from '@/components/contents/ContentExportOverlay'

export default {
  name: 'SearchBar',
  mixins: [FormMixin],
  components: {
    FontAwesomeIcon,
    ContentLayoutSwitch,
    SearchFilterOverlay,
    ContentExportOverlay
  },
  data () {
    return {
      term: ''
    }
  },
  computed: {
    ...mapState({
      contents: state => state.contents.contents,
      searchTerm: state => state.contentFilter.filter.term,
      sortDirection: state => state.contentFilter.filter.sortDir
    }),
    ...mapGetters({
      sortByOptions: 'contentFilter/sortByOptions',
      sortDirOptions: 'contentFilter/sortDirOptions'
    }),
    sortDirIcon () {
      return this.sortDirection == 'desc'
        ? 'sort-amount-down'
        : 'sort-amount-up'
    }
  },
  methods: {
    ...mapActions({
      fetchContents: 'contents/fetch',
      setContents: 'contents/apply',
      resetContents: 'contents/reset',
      resetSearch: 'contentFilter/reset',
      loadingStart: 'app/loadingStart',
      loadingDone: 'app/loadingDone'
    }),
    ...mapActions([
      'openOverlay',
      'openFullscreenModal'
    ]),
    openShareContentModal () {
      alert('share')
    },
    openFilterModal () {
      this.openOverlay('SearchFilterOverlay')
    },
    openExportModal () {
      this.openFullscreenModal('ContentExportOverlay')
    },
    customSubmit () {
      this.loadingStart()
      this.$store.dispatch('contentFilter/setTerm', this.term)
      this.$store.dispatch('contentFilter/setPerPage', 96)
      this.fetchContents()
        .then((response) => {
          this.setContents(response)
          this.loadingDone()
        })
    },
    reset () {
      this.term = ''
      this.resetContents()
      this.resetSearch()
    },
    handleSortBySelect ({ value }) {
      this.$store.dispatch('contentFilter/setSortBy', value)
      this.loadingStart()
      this.fetchContents()
        .then(() => {
          this.loadingDone()
        })
    }
  },
  created () {
    this.term = this.$store.state.contentFilter.filter.term
  }
}
</script>

<style lang="sass">
@import '~styles/imports'

.search-bar
  &__wrapper
    text-align: center
    margin-bottom: rem-calc($grid-gutter-width * 2)
    display: flex
    justify-content: center
    align-items: center
    gap: 20px

  &__input
    border: 0
    border-bottom: 1px dashed #ccc
    margin: 0 auto
    padding: 10px
    font-family: $font-1
    font-size: 48px
    font-weight: 900
    text-align: center
    outline: none
    width: 100%

    &:focus,
    &:hover
      border-color: $color-1

  &__controls
    display: flex
    justify-content: space-between
    margin-bottom: 20px

  &__column
    width: 33%

    &--center
      display: flex
      justify-content: center

    &--right
      display: flex
      justify-content: flex-end

      .button-input
        margin-left: 10px

    .button-input
      background-color: var(--mainColor)
</style>



// WEBPACK FOOTER //
// src/components/search/SearchBar.vue